import axios from "axios";
import config from "../../../../config/config";

export const PROFILE_URL = config.baseUrl;

// READ

export function addCredit(user) {
  return axios.post(PROFILE_URL + "wallet/pay/", {
    headers: { "x-access-token": user.accessToken },
  });
}

export function getProfileInfo(user) {
  return axios.get(PROFILE_URL + "user/getUserProfile", {
    headers: { "x-access-token": user.accessToken },
  });
}
export function getSupportItems(user) {
  return axios.get(PROFILE_URL + "getSupportItems", {
    headers: { "x-access-token": user.accessToken },
  });
}

export function getUserTransactionReports(user,data) {
  return axios.get(PROFILE_URL + "user/getUserTransactionReports", {
    headers: { "x-access-token": user.accessToken },
    params:data
  });
}

export function updatePassword(user, data) {
  return axios.post(PROFILE_URL + "auth/changeUserPassword", data, {
    headers: { "x-access-token": user.accessToken },
  });
}

export function createSupportItemTicket(user, data) {
  return axios.post(PROFILE_URL + "createSupportItemTicket", data, {
    headers: { "x-access-token": user.accessToken },
  });
}

export function updateProfileInfo(user, data) {
  return axios.put(PROFILE_URL + "user/updateUserProfile", data, {
    headers: { "x-access-token": user.accessToken },
  });
}

export function sendRefund(user, data) {
  return axios.post(PROFILE_URL + "refund", data, {
    headers: { "x-access-token": user.accessToken },
  });
}

export function getUserTravels(user, data) {
  return axios.get(PROFILE_URL + "travel/user/userTravelReport", {
    headers: { Authorization: `Bearer ${user.token}` },
    params:data
  });
}

export function getTransactions(token) {
  const data = {
    intext: {
      token: token,
    },
  };
  return axios.post(PROFILE_URL + "rep_user_transactions", data);
}

export function getReports(user,data) {
  return axios.get(PROFILE_URL + "getSupportItemTickets", {
    headers: { "x-access-token": user.accessToken },
    params:data
  });
}

export function getUserCredit(user) {
  return axios.get(PROFILE_URL + "getUserCredit", {
    headers: { "x-access-token": user.accessToken },
  });
}
//
// // CREATE =>  POST: add a new passenger to the server
// export function createPassenger(passenger) {
//     const intext = passenger
//     console.log(passenger)
//     return axios.post(`${PROFILE_URL}add_favorite_passengers`, { intext });
// }
//
//
// export function getPassengerById(passenger) {
//   passenger = JSON.parse(passenger)
//   return passenger;
//   // return axios.get(`${PASSENGER_URL}/${passenger}`);
// }
//
// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findPassengers(user) {
//   const intext = {
//       "token" : user.AccessToken
//   }
//   return axios.post(`${PASSENGER_URL}get_favorite_passengers`, { intext });
// }
//
// // UPDATE => PUT: update the passenger on the server
// export function updatePassenger(passenger) {
//   //TODO: Replace with update passenger service
//   console.log(passenger)
//   return axios.put(`${PASSENGER_URL}/${passenger.id}`, { passenger });
// }
//
// // UPDATE Status
// export function updateStatusForPassengers(ids, status) {
//   return axios.post(`${PASSENGER_URL}/updateStatusForPassengers`, {
//     ids,
//     status
//   });
// }
//
// // DELETE => delete the passenger from the server
// export function deletePassenger(intext) {
//   return axios.post(`${PASSENGER_URL}delete_favorite_passengers`, { intext });
// }
//
// // DELETE Passengers by ids
// export function deletePassengers(ids) {
//   return axios.post(`${PASSENGER_URL}/delete_favorite_passengers`, { ids });
// }
